import { Box, Card, Text } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

interface ContentCardProps extends PropsWithChildren {
    header?: React.ReactNode;
    width?: number;
    height?: number;
    background?: string;
}

const ContentCard = ({ children, header, width, height, background }: ContentCardProps) => {
    return (
        <Card.Root 
            borderRadius={16} 
            variant='elevated' 
            width={width}
            minW={width}
            height={height} 
            backgroundColor={background}
        >
            {header && 
                <Card.Header p={5} pb={0}>
                    {header}
                </Card.Header>
            }
            <Card.Body p={5}>
                {children}
            </Card.Body>
        </Card.Root>
    )
}

export default ContentCard;